module.exports = __webpack_public_path__ + "static/media/partner7.040efc49.png";